module.exports = __webpack_public_path__ + "94d53b491c52f2f7b680947bd5d44085.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/denim-jacket-s.png
// module id = 1828
// module chunks = 0